function activationBtn() {
	$('.activationBtn').on('click', function() {
		$('.activation-alert').fadeOut();
	})
}